import { createContext, ReactNode, useMemo } from 'react';

interface SplitConfigContextValue {
  isSplitConfigured: boolean;
}

export const SplitConfigContext = createContext<SplitConfigContextValue | undefined>(
  undefined,
);

interface SplitConfigProviderProps extends SplitConfigContextValue {
  children: ReactNode;
}

export const SplitConfigProvider = ({
  children,
  isSplitConfigured,
}: SplitConfigProviderProps) => {
  const value = useMemo(() => ({ isSplitConfigured }), [isSplitConfigured]);

  return (
    <SplitConfigContext.Provider value={value}>{children}</SplitConfigContext.Provider>
  );
};
